import React from 'react';
import { SortAction } from '../types';

type DataTableheaderDrawerProps<T> = {
  filterActions: React.ReactNode | React.ReactNode[];
  onSort?: (action: SortAction<T>) => void;
};

function DataTableHeaderDrawer<T>({
  filterActions,
}: DataTableheaderDrawerProps<T>): JSX.Element {
  return (
    <div className='border-b border-gray-light px-8 py-5'>{filterActions}</div>
  );
}

export default DataTableHeaderDrawer;
